import {
  ThreadFilter,
  ThreadStatus,
  SearchThreadsResponseItem
} from "@/pb/scout/message/v1/message_pb";
import { ThreadFilterValue } from "@/components/Pages/Scout/Messages/ThreadUserList/types";
import { MessageThreadUser } from "@/components/Pages/Scout/Messages/ThreadUserList/ThreadUser/types";
import { useStore } from "@/store";
import {
  searchAgentMessageThreads,
  searchMessageThreads
} from "@/grpc-web/scout/message";

// スカウトエージェントメニューがアクティブ状態かどうかを判定する
const isScoutAgentMenuActive = () => {
  const store = useStore();
  return store.getters["domains/user/isScoutAgentMenuActive"];
};

export const fetchMessageThreads = async (
  filter: ThreadFilter,
  nameOrUniqueId: string,
  unansweredOnly: boolean,
  page: number,
  per: number
) => {
  if (isScoutAgentMenuActive()) {
    return await searchAgentMessageThreads(
      filter,
      nameOrUniqueId,
      unansweredOnly,
      page,
      per
    );
  }

  return await searchMessageThreads(
    filter,
    nameOrUniqueId,
    unansweredOnly,
    page,
    per
  );
};

export const convertThreadFilterValueToThreadFilter = (
  value: ThreadFilterValue
) => {
  switch (value) {
    case ThreadFilterValue.FILTER_ALL:
      return ThreadFilter.THREAD_FILTER_UNSPECIFIED;
    case ThreadFilterValue.FILTER_USER_ACCEPTED:
      return ThreadFilter.THREAD_FILTER_ACCEPTED;
    case ThreadFilterValue.FILTER_USER_DECLINED:
      return ThreadFilter.THREAD_FILTER_DECLINED;
    case ThreadFilterValue.FILTER_USER_UNANSWERED:
      return ThreadFilter.THREAD_FILTER_UNANSWERED;
    default:
      return ThreadFilter.THREAD_FILTER_UNSPECIFIED;
  }
};

export const convertSearchThreadsResponseItemToMessageThreadUser = (
  item: SearchThreadsResponseItem
): MessageThreadUser => {
  return {
    messageThreadId: item.getThreadId(),
    // item.getUser()はバックエンド側では常に返却している。protoもoptionalではないが、型がundefinedを含むので、それを考慮したコードにする
    userId: item.getUser()?.getId() ?? 0,
    // APIのレスポンスには含まれないが、後から画像取得APIを呼び出し設定するので空文字で初期化する
    userImageUrl: "",
    name: extractNameFromSearchThreadsResponseItem(item),
    uniqueId: item.getUser()?.getUniqueId() ?? "",
    lastMessageTimestampMs: item.getLastCommentAtMs(),
    description: extractDescriptionFromSearchThreadsResponseItem(item),
    lastMessageText: item.getLastComment(),
    unreadCommentCount: item.getUnreadCount()
  };
};

const extractNameFromSearchThreadsResponseItem = (
  item: SearchThreadsResponseItem
) => {
  if (item.getStatus() !== ThreadStatus.THREAD_STATUS_ACCEPTED) {
    return undefined;
  }
  const user = item.getUser();
  // 姓名両方存在しない場合はundefinedを返却する。どちらか一方でも存在する場合は姓名を組み立てて返却する。
  if (!user || (!user.hasLastName() && !user.hasFirstName())) {
    return undefined;
  }

  return [user.getLastName(), user.getFirstName()].join(" ");
};

const extractDescriptionFromSearchThreadsResponseItem = (
  item: SearchThreadsResponseItem
) => {
  return `${item
    .getUser()
    ?.getUniversityName()} ${item
    .getUser()
    ?.getDepartmentName()} ${item.getUser()?.getConcentrationName()}`;
};
